import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { InstantAccess } from './components/sections/InstantAccess';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="23ti7e2craqj5">
      <MetaPixel data-id="element-1" data-mp="3ij64a9st9l7v" />
      <Hero data-id="element-2" data-mp="3ijpcgysnsv8p" />
      <main data-id="element-3" data-mp="3ihv1ac76whht">
        <BeforeAfter data-id="element-4" data-mp="3mljat0fdtn5p" />
        <PainPoints data-id="element-5" data-mp="3ml12h5fg3ihf" />
        <Volumes data-id="element-6" data-mp="3mkhofzsx1e8o" />
        <InstantAccess data-id="element-7" data-mp="3mjzpgvevclx2" />
        <Bonuses data-id="element-8" data-mp="3mj6k9yvk64h1" />
        <Offer data-id="element-9" data-mp="3rcj7c4kla37o" />
        <Guarantee data-id="element-10" data-mp="3rbzlwdvqcwow" />
        <Testimonials data-id="element-11" data-mp="3rdkg22e4udm8" />
        <About data-id="element-12" data-mp="3recerm310rgq" />
        <FAQ data-id="element-13" data-mp="3relwynhtxubv" />
        <FinalCTA data-id="element-14" data-mp="5or2zhbcs60" />
      </main>
      <Footer data-id="element-15" data-mp="4ww9qvjiygs" />
      <FloatingCTA data-id="element-16" data-mp="5ggje8nxyxz" />
      <PurchasePopup data-id="element-17" data-mp="82jf0klzq9v" />
    </div>;
}